module.exports = __webpack_public_path__ + "static/media/eprize1.383daf42.png";